// src/components/Datenschutz.jsx
import React from 'react';
import { Link } from 'react-router-dom';

const Datenschutz = () => {
  return (
    <div className="card shadow-sm">
      <div className="card-body">
        <h1 className="card-title">Datenschutzerklärung</h1>

        <p>
          Der Schutz Ihrer persönlichen Daten ist uns wichtig. Nachfolgend informieren wir Sie über die Erhebung,
          Verwendung und Verarbeitung personenbezogener Daten auf dieser Website.
        </p>

        <h5>1. Verantwortlicher</h5>
        <p>Dominik Ruf — Am Maueranger 16 — 76228 Karlsruhe</p>

        <h5>2. Erhebung und Verwendung</h5>
        <p>
          Wir erheben nur die für den Betrieb der Website notwendigen Daten. Wenn Sie Kontaktformulare verwenden,
          werden die dort eingegebenen Daten (z. B. Name, E-Mail, Nachricht) zur Bearbeitung Ihres Anliegens verarbeitet.
        </p>

        <h5>3. Cookies & Einwilligung</h5>
        <p>
          Diese Website verwendet ggf. Cookies. Hinweise zur Einwilligung und Cookie-Einstellungen finden Sie über
          die Schaltfläche „Cookie-Einstellungen“ im Footer. Sie können dort Einwilligungen verwalten oder widerrufen.
        </p>

        <h5>4. Rechtsgrundlagen</h5>
        <p>
          Die Rechtsgrundlage für die Verarbeitung personenbezogener Daten richtet sich nach Art. 6 DSGVO. Sofern
          Sie ausdrücklich eingewilligt haben, erfolgt die Verarbeitung auf Grundlage Ihrer Einwilligung (Art. 6 Abs. 1 lit. a).
        </p>

        <p className="small text-muted">
          Dies ist eine vereinfachte, allgemeine Datenschutzerklärung als Vorlage. Passen Sie die Inhalte an Ihre tatsächlichen
          Verarbeitungen an (Analytics, Third-Party-Tools, Hosting, E-Mail-Provider etc.) und lassen Sie sie ggf. juristisch prüfen.
        </p>

        <p>
          <Link to="/impressum">Zurück zum Impressum</Link>
        </p>
      </div>
    </div>
  );
};

export default Datenschutz;
